<template>
  <div class="w-100 advanced-search d-flex column flex-grow">
    <vx-card>
      <div class="vx-row gutter-half">
        <div class="vx-col w-full overflow-x-auto">
          <vx-input-group class="custom-input-group">
            <div class="d-flex">
              <span class="label">Media Type: </span>
              <div class="vx-input-group-append flex-grow">
                <div class="append-text btn-addon">
                  <vs-button
                    color="primary"
                    type="border"
                    v-for="(v, i) in types"
                    :key="i"
                    @click="toggleMediaType(v.value)"
                    class="radiobtn"
                    :class="{selected: $store.state.globalSearchAssetTypes.indexOf(v.value) !== -1}">
                    {{ v.name }}
                  </vs-button>
                </div>
              </div>
            </div>
          </vx-input-group>
        </div>
      </div>
    </vx-card>
    <div class="pr">
      <div class="loader-block loader-block2" v-if="isLoading" style="min-height: 200px;">
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </div>
      <div class="vx-row">
        <SmartClickWrapper class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 lg:w-1/5 d-flex"
                           v-for="(item, index) in items" :key="index" :onClick="() => showGlobalAsset(item)">
          <GlobalAssetItem :item="item" :show-images="showImages" :isMyLibrary="true" />
        </SmartClickWrapper>
      </div>
    </div>
    <assetModal :id="isAssetModal" :withLink="true" v-if="isAssetModal" v-on:closeModal="closeAssetModal"
                :locale="filters.locale"
                :no-edit="true" :formatReference="filters && filters.goal && filters.goal.format_reference" />
    <globalAssetModal :_item="isGlobalAssetModal" :withLink="true" :demoContent="true" v-if="isGlobalAssetModal"
                      :showLanguages="false"
                      v-on:closeModal="closeGlobalAssetModal" />
  </div>
</template>

<script>

import axios from "axios";
import vSelect from 'vue-select'
import GlobalAssetItem from "../components/GlobalAssetItem";
import CustomSvg from "../components/CustomSvg";
import assetModal from "../components/modal/assetModal";
import globalAssetModal from "../components/modal/globalAssetModal";
import powerSchoolers from "../components/modal/powerSchoolers";
import { quizes2D, quizes3D } from "@/utils/constants/quizTypes.js";
import defaultGoalsExams from "@/utils/constants/defaultGoalsExams.js";
import { getGoalsExamsSubjects } from "@/utils/fetchers/getGoalsExamsSubjects.js";
import { getUnits } from "@/utils/fetchers/getUnits.js";
import { hcLanguages } from "@/utils/constants/hcLanguages.js";
import SmartClickWrapper from "@/components/SmartClickWrapper.vue";

const quizTypeRegexp = new RegExp([...quizes3D, ...quizes2D].join("|"), "gi");

export default {
  name: "GlobalSearch",
  components: {SmartClickWrapper, vSelect, GlobalAssetItem, CustomSvg, assetModal, globalAssetModal, powerSchoolers},
  props: {},
  data() {
    return {
      hcLanguages,
      filters: {
        _search: "",
        order_by: "updatedAt",
        order: "desc",
        locale: "en",
      },
      types: [
        {value: "any", name: "Any"},
        {value: "simulations", name: "Virtual Labs"},
        {value: "videos", name: "Videos"},
        {value: "activities", name: "Activities"},
        {value: "coobos", name: "Lessons"},
      ],
      items: [],
      currentPage: 1,
      totalItems_3D: 0,
      loadedItems_3D: 0,
      totalItems_Image: 0,
      loadedItems_Image: 0,
      totalItems_Animation: 0,
      loadedItems_Animation: 0,
      totalItems_Simulations: 0,
      loadedItems_Simulations: 0,
      totalItems_Coobos: 0,
      loadedItems_Coobos: 0,
      totalItems_Videos: 0,
      loadedItems_Videos: 0,
      totalItems_Activities: 0,
      loadedItems_Activities: 0,
      itemsPerPage: 15,
      totalPages: 0,
      showImages: true,
      isLoading: true,
      lmDebounce: false,
      lmFormats: [],
      cancelSearchToken: [],
      isAssetModal: false,
      isGlobalAssetModal: false,
    }
  },
  computed: {
    hcData() {
      return this.$store.state.hcData;
    },
  },
  mounted() {
    axios.get("/demo.json").then((data) => {
      this.$store.commit("setState", {hcData: data.data});
      this.fetchItems();
    })
    this.getEmbibeToken();
  },
  destroyed() {
  },
  methods: {
    getEmbibeToken() {
      this.$axios.request({
        method: 'post',
        url: 'https://beta-api.embibe.com/coobo_ms/licence-keys/activate?locale=en',
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        data: JSON.stringify({"licence_key": "111111111111", "device_id": "uhktr"})
      }).then(res => {
        // console.log(res);
      })
    },
    showGlobalAsset(item) {
      if (item.asset_object_id) {
        this.isAssetModal = item.asset_object_id
      } else {
        this.isGlobalAssetModal = {...item};
      }
    },
    closeAssetModal() {
      this.isAssetModal = false;
    },
    closeGlobalAssetModal() {
      this.isGlobalAssetModal = false;
    },
    toggleMediaType(type) {
      const ind = this.$store.state.globalSearchAssetTypes.indexOf(type);
      this.$store.commit("setState", {globalSearchAssetTypes: type ? [type] : []});
      const voiceOverValues = {
        any: "",
        simulations: "yes",
        videos: "yes",
        activities: "no",
        "3D": "no",
        coobos: "",
        image: "no",
        animation: "no",
      }
      this.filters.voiceover = voiceOverValues[type];
      if (type && ind === -1) this.fetchItems(false)
    },
    hcSearch(facet, opts = {}) {
      const _facet = facet === "activities" ? "coobos" : facet;
      const items = (this.hcData[facet] || [])
        .map(_item => {
          const item = {..._item};
          item.asset_type = _facet;
          item.subtype = facet;
          item.thumbnail = (item.thumbnail || {}).landscape || (item.thumbnail || {}).portrait || item.thumbnail;
          if (facet === "activities") {
            item.quizType = opts.search || (item.description.match(quizTypeRegexp) || [])[0];
          }
          return item;
        })
      return Promise.resolve({items, count: items.length, assetType: facet});
    },
    getAssetCount(no_of_results, assetType) {
      let count = no_of_results;
      const overrideCounters = {
        lessons: {condition: n => n === 10000, count: 11228},
        coobos: {condition: n => n === 10000, count: 11228},
        activities: {condition: n => n === 10000, count: 9181},
        videos: {condition: n => n > 7000, count: 15619},
        simulations: {condition: n => n > 600, count: 723},
      }
      if (overrideCounters[assetType] && overrideCounters[assetType].condition(no_of_results)) {
        count = overrideCounters[assetType].count;
      }
      return count;
    },
    resetCounters() {
      this.totalItems_Simulations = 0;
      this.loadedItems_Simulations = 0;
      this.totalItems_Coobos = 0;
      this.loadedItems_Coobos = 0;
      this.totalItems_Videos = 0;
      this.loadedItems_Videos = 0;
      this.totalItems_Activities = 0;
      this.loadedItems_Activities = 0;
    },
    capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    fetchItems() {
      this.isLoading = true;
      clearTimeout(this.fetchDebounce);
      this.fetchDebounce = setTimeout(() => {
        this.items = [];
        this.currentPage = 1;
        this.resetCounters()
        let promises = [];
        const asset_types = this.$store.state.globalSearchAssetTypes;
        if (asset_types && asset_types.length && !asset_types.includes("any")) {
          if (asset_types.includes('simulations')) {
            promises.push(this.hcSearch('simulations'))
          }
          if (asset_types.includes('coobos')) {
            promises.push(this.hcSearch('coobos'))
          }
          if (asset_types.includes('activities')) {
            promises.push(this.hcSearch('activities'));
          }
          if (asset_types.includes('videos')) {
            promises.push(this.hcSearch('videos'))
          }
        } else {
          promises.push(this.hcSearch('simulations'));
          promises.push(this.hcSearch('videos'));
          promises.push(this.hcSearch('activities'));
          promises.push(this.hcSearch('coobos'))
        }
        Promise.all(promises).then((results) => {
          this.items.push(...results.map(r => r.items || []).flat());
          console.log(this.items);
          results.forEach(r => {
            if (r.assetType) {
              const capitalizedAssetType = this.capitalize(r.assetType);
              const totalItemsKey = `totalItems_${capitalizedAssetType}`;
              const loadedItemsKey = `loadedItems_${capitalizedAssetType}`;
              if ("count" in r) {
                this[totalItemsKey] = this.getAssetCount(r.count, r.assetType);
              }
              if ('items' in r && r.items.length) {
                this[loadedItemsKey] += r.items.length;
              }
            }
          })
          this.isLoading = false;
        })
      }, 500)
    },
  },
}
</script>

<style>
.advanced-search .label {
  width: 95px;
}

.v-select .vs__dropdown-menu .vs__dropdown-option {
  word-break: normal;
}
</style>
